var Icon, m;

m = require('mithril');

Icon = require('./Icon');

module.exports = {
  view: function(ctrl, args) {
    var ref, ref1;
    return m('.Account', m('span.Account__link', {
      onclick: function() {
        return m.route('/login');
      }
    }, [Icon.profile(), m('span.Account__name', "" + ((ref = (ref1 = args.account) != null ? ref1.name : void 0) != null ? ref : 'N/A'))]));
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9BY2NvdW50LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3VpL2NvbXBvbmVudHMvQWNjb3VudC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBQ0osSUFBQSxHQUFPLE9BQUEsQ0FBUSxRQUFSOztBQUVQLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLElBQUEsRUFBTSxTQUFDLElBQUQsRUFBTyxJQUFQO0FBQ0wsUUFBQTtXQUFBLENBQUEsQ0FBRSxVQUFGLEVBQWMsQ0FBQSxDQUFFLG9CQUFGLEVBQXdCO01BQUMsT0FBQSxFQUFTLFNBQUE7ZUFBTSxDQUFDLENBQUMsS0FBRixDQUFRLFFBQVI7TUFBTixDQUFWO0tBQXhCLEVBQTJELENBQ3hFLElBQUksQ0FBQyxPQUFMLENBQUEsQ0FEd0UsRUFFeEUsQ0FBQSxDQUFFLG9CQUFGLEVBQXdCLEVBQUEsR0FBRSw0RUFBc0IsS0FBdEIsQ0FBMUIsQ0FGd0UsQ0FBM0QsQ0FBZDtFQURLLENBRFUifQ==
